import React from 'react';

export default class Page8 extends React.Component {

    render() {

        const {pageData} = this.props;

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">

                                <div className="ilead-rgt ">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Step 2: Scoring the self-analysis
                                                questionnaire
                                            </div>
                                            <p>Use the following 2-step process to score your results.</p>
                                            <div className="chklist_stmt_cover page7">
                                                <div className="chklist_stmt_index" style={{marginTop: '10px'}}>
                                                    <span>1.</span>
                                                </div>
                                                <div className="chklist_stmt" style={{marginTop: '10px'}}>
				<span style={{fontFamily: 'ek_muktalight, san-serif !important'}}>Look at each category and add the corresponding Red (R), Amber (A), Green (G) ratings to formulate your unique combination. An example
				has been completed for you:</span>
                                                </div>
                                            </div>
                                            <p style={{paddingTop:'15px'}}>
                                                <strong>Example:
                                                </strong>
                                            </p>
                                            <table className="ilead_v_sport analysis_vsport2" width="100%"
                                                   cellspacing="0"
                                                   cellpadding="0" border="0" style={{margin: '0 auto'}}>
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left"
                                                        style={{paddingLeft:'10px'}}>Area
                                                    </th>
                                                    <th align="left" style={{paddingLeft:'10px'}}>Items to Add</th>
                                                    <th className="green_curve1" align="left"
                                                        style={{paddingLeft:'10px'}}>Combination
                                                    </th>
                                                </tr>
                                                <tr>
                                                    <td height="30">
                                                        <span className="greentxt_bigfont">V</span>
                                                    </td>
                                                    <td align="left">
                                                        <span className="greentextorange1">1</span>
                                                        -
                                                        <span className="greentextorange1">3</span>
                                                    </td>
                                                    <td>
                                                        <span className="rag_Com_r">R</span>-<span
                                                        className="rag_Com_a">A</span>-<span
                                                        className="rag_Com_g">G</span>
                                                    </td>
                                                </tr>
                                                </tbody>
                                            </table>
                                            <p style={{paddingTop:'20px'}}><strong>Your Template to Complete:</strong></p>


                                            <p className="pbodyfont_modified">
                                                <table width="100%" border="0" cellspacing="0" cellpadding="0"
                                                       className="ilead_v_sport analysis_vsport2"
                                                       style={{margin: '0 auto'}}>
                                                    <tbody>
                                                    <tr>

                                                        <th className="green_curve" align="left"
                                                            style={{paddingLeft:'10px'}}>Area
                                                        </th>
                                                        <th align="left" style={{paddingLeft:'10px'}}>Items to Add</th>
                                                        <th className="green_curve1" align="left"
                                                            style={{paddingLeft:'10px'}}>Combination
                                                        </th>
                                                    </tr>
                                                    <tr>
                                                        <td height="50"><span className="greentxt_bigfont">V</span></td>
                                                        <td align="left">1-3</td>
                                                        <td>
                                                            <span className="rag_Com_r">{pageData?.V?.[1] || ' '}</span>-
                                                            <span className="rag_Com_a">{pageData?.V?.[2] || ' '}</span>-
                                                            <span className="rag_Com_g">{pageData?.V?.[3] || ' '}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="altbackground">
                                                        <td height="50" className="lgtgreenbg"><span
                                                            className="greentxt_bigfont">S</span></td>
                                                        <td align="left">4-6</td>
                                                        <td>
                                                            <span className="rag_Com_r">{pageData?.S?.[4] || ' '}</span>-
                                                            <span className="rag_Com_a">{pageData?.S?.[5] || ' '}</span>-
                                                            <span className="rag_Com_g">{pageData?.S?.[6] || ' '}</span>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td height="50"><span className="greentxt_bigfont">P</span></td>
                                                        <td align="left">7-9</td>
                                                        <td>
                                                            <span className="rag_Com_r">{pageData?.P?.[7] || ' '}</span>-
                                                            <span className="rag_Com_a">{pageData?.P?.[8] || ' '}</span>-
                                                            <span className="rag_Com_g">{pageData?.P?.[9] || ' '}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="altbackground">
                                                        <td height="50" className="lgtgreenbg"><span
                                                            className="greentxt_bigfont">O</span></td>
                                                        <td align="left">10-12</td>
                                                        <td>
                                                            <span className="rag_Com_r">{pageData?.O?.[10] || ' '}</span>-
                                                            <span className="rag_Com_a">{pageData?.O?.[11] || ' '}</span>-
                                                            <span className="rag_Com_g">{pageData?.O?.[12] || ' '}</span>
                                                        </td>
                                                    </tr>

                                                    <tr>
                                                        <td height="50"><span className="greentxt_bigfont">R</span></td>
                                                        <td align="left">13-15</td>
                                                        <td>
                                                            <span className="rag_Com_r">{pageData?.R?.[13] || ' '}</span>-
                                                            <span className="rag_Com_a">{pageData?.R?.[14] || ' '}</span>-
                                                            <span className="rag_Com_g">{pageData?.R?.[15] || ' '}</span>
                                                        </td>
                                                    </tr>

                                                    <tr className="altbackground">
                                                        <td height="50" className="lgtgreenbg"
                                                            style={{borderBottomLeftRadius:'20px'}}><span
                                                            className="greentxt_bigfont">T</span></td>
                                                        <td align="left">16-18</td>
                                                        <td>
                                                            <span className="rag_Com_r">{pageData?.T?.[16] || ' '}</span>-
                                                            <span className="rag_Com_a">{pageData?.T?.[17] || ' '}</span>-
                                                            <span className="rag_Com_g">{pageData?.T?.[18] || ' '}</span>
                                                        </td>
                                                    </tr>

                                                    </tbody>
                                                </table>
                                            </p>


                                            <div className="chklist_stmt_cover page7"
                                                 style={{paddingTop:'30px',paddingBottom:'40px'}}>
                                                <div className="chklist_stmt_index" style={{marginTop: '10px'}}>
                                                    <span>2.</span>
                                                </div>
                                                <div className="chklist_stmt" style={{marginTop: '10px'}}>
				<span style={{fontFamily: 'ek_muktalight, san-serif !important'}}>Now, record your strengths and aspects in need of development in the Strength/ Development summary below. Use the
				table to help you translate your combination into the relevant Strength/Development category:</span>
                                                </div>
                                            </div>


                                            <table className="ilead_v_sport ilead_v_sport_new_task analysis_vsport2"
                                                   width="100%" cellspacing="0" cellpadding="0" border="0"
                                                   style={{margin: '0 auto'}}>
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve" align="left" style={{paddingLeft:'10px'}}
                                                        colspan="2">Combination
                                                    </th>
                                                    <th className="green_curve1" align="left"
                                                        style={{paddingLeft:'10px'}}>Strength/Development
                                                    </th>
                                                </tr>
                                                <tr className="altbackground">
                                                    <td>
                                                <span className="greentextorange1"><span className="rag_Com_g">G</span>-<span
                                                    className="rag_Com_g">G</span>-<span className="rag_Com_g">G</span></span>
                                                    </td>
                                                    <td align="left">
                                                <span className="greentextorange1"><span className="rag_Com_g">G</span>-<span
                                                    className="rag_Com_g">G</span>-<span className="rag_Com_a">A</span></span>
                                                    </td>
                                                    <td>Significant Strength</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                <span className="greentextorange1"><span className="rag_Com_g">G</span>-<span
                                                    className="rag_Com_g">G</span>-<span className="rag_Com_r">R</span></span>
                                                    </td>
                                                    <td align="left">
                                                <span className="greentextorange1"><span className="rag_Com_g">G</span>-<span
                                                    className="rag_Com_a">A</span>-<span className="rag_Com_a">A</span></span>

                                                    </td>
                                                    <td>Strength

                                                    </td>
                                                </tr>
                                                <tr className="altbackground">
                                                    <td>
                                                <span className="greentextorange1"><span className="rag_Com_a">A</span>-<span
                                                    className="rag_Com_a">A</span>-<span className="rag_Com_a">A</span></span>
                                                    </td>
                                                    <td align="left">
                                                <span className="greentextorange1"><span className="rag_Com_g">G</span>-<span
                                                    className="rag_Com_a">A</span>-<span className="rag_Com_r">R</span></span>
                                                    </td>
                                                    <td>Average/mixed

                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                <span className="greentextorange1"><span className="rag_Com_g">G</span>-<span
                                                    className="rag_Com_r">R</span>-<span className="rag_Com_r">R</span></span>
                                                    </td>
                                                    <td align="left">
                                                <span className="greentextorange1"><span className="rag_Com_a">A</span>-<span
                                                    className="rag_Com_a">A</span>-<span className="rag_Com_g">R</span></span>

                                                    </td>
                                                    <td>Development need

                                                    </td>
                                                </tr>
                                                <tr className="altbackground">
                                                    <td>
                                                <span className="greentextorange1"><span className="rag_Com_g">A</span>-<span
                                                    className="rag_Com_r">R</span>-<span className="rag_Com_r">R</span></span>
                                                    </td>
                                                    <td align="left">
                                                <span className="greentextorange1"><span className="rag_Com_r">R</span>-<span
                                                    className="rag_Com_r">R</span>-<span className="rag_Com_r">R</span></span>

                                                    </td>
                                                    <td>Significant development need

                                                    </td>
                                                </tr>


                                                </tbody>
                                            </table>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page7')}
                                                     className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page9')}
                                                     className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}